/* Copyright (c) 2017 Backpack Health LLC */
/* eslint-disable no-param-reassign */
import * as _ from 'lodash';

export const medliTermConversions = {
  convertSearchTermToTerm: (medliSearchTerm, languageCode) => ({
    id: medliSearchTerm.id,
    position: medliSearchTerm.position || undefined,
    transaction_id: medliSearchTerm.transaction_id || undefined,
    strings: {
      [languageCode]: medliSearchTerm.string,
    },
    canonical_strings: {
      [languageCode]: medliSearchTerm.canonical_string,
    },
  }),
};

function medliTerm(healthEntryCategoryState, languageCode) {
  healthEntryCategoryState.term = healthEntryCategoryState.term || { id: '', strings: [] };

  return {
    convertToSearchTerm: () => ({
      id: healthEntryCategoryState.term.id,
      string: healthEntryCategoryState.term.strings[languageCode],
    }),
    replaceWithSearchTerm: (medliSearchTerm) => {
      healthEntryCategoryState.term = medliTermConversions.convertSearchTermToTerm(medliSearchTerm, languageCode);
    },
    formattedTermName: (forceLanguageCode) => {
      const code = forceLanguageCode || languageCode;
      return _.get(healthEntryCategoryState, 'term.strings', {})[code];
    },
    canonicalName: (forceLanguageCode) => {
      const code = forceLanguageCode || languageCode;
      return _.get(healthEntryCategoryState, 'term.canonical_strings', {})[code] || '';
    },
    set: (medliData) => { healthEntryCategoryState.term = medliData; },

    needsLocalization: () => this.otherMedliTerm && this.otherMedliTerm.hasOther(),
    localizationData: (forceLanguageCode) => {
      const code = forceLanguageCode || languageCode;
      return {
        id: 'healthEntry.otherAllergy.name.text',
        values: {
          string1: this.otherMedliTerm.formattedTermName(code),
        },
      };
    },
    getCui: () => healthEntryCategoryState.term.cui ? healthEntryCategoryState.term.cui : '',
  };
}

export function otherMedliTerm(healthEntryCategoryState, languageCode) {
  healthEntryCategoryState.other = healthEntryCategoryState.other || { id: '', strings: [] };

  return {
    convertToSearchTerm: () => ({
      id: healthEntryCategoryState.other.id,
      string: healthEntryCategoryState.other.strings[languageCode],
    }),
    replaceWithSearchTerm: (medliSearchTerm) => {
      healthEntryCategoryState.other = medliTermConversions.convertSearchTermToTerm(medliSearchTerm, languageCode);
    },
    formattedTermName: (forceLanguageCode) => {
      const code = forceLanguageCode || languageCode;
      return _.get(healthEntryCategoryState, 'other.strings', {})[code];
    },
    canonicalName: (forceLanguageCode) => {
      const code = forceLanguageCode || languageCode;
      return _.get(healthEntryCategoryState, 'other.canonical_strings', {})[code] || '';
    },
    set: (medliData) => { healthEntryCategoryState.other = medliData; },
    hasOther: () => healthEntryCategoryState.other.id !== '',
  };
}

export function subType(healthEntryCategoryState) {
  healthEntryCategoryState.type = healthEntryCategoryState.type || '';

  return {
    get: () => healthEntryCategoryState.type,
    set: (newType) => { healthEntryCategoryState.type = newType; },
    hasSubType: () => healthEntryCategoryState.type !== '',
    getPhraseKey: () => {
      if (healthEntryCategoryState.type === 'food') {
        return 'list.healthEntry.allergiesFood.name';
      } else if (healthEntryCategoryState.type === 'medication') {
        return 'list.healthEntry.allergiesMedication.name';
      } else {
        return 'list.healthEntry.allergiesOther.name';
      }
    },
  };
}

export function cleanMedliTermWithSubType(healthEntryCategoryState) {
  const otherId = _.get(healthEntryCategoryState, 'other.id', '');
  if (otherId === '' || otherId === null) {
    healthEntryCategoryState = _.omit(healthEntryCategoryState, ['other']);
  }

  return healthEntryCategoryState;
}

export default medliTerm;
